import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import LockWrapper from "./LockWrapper";

const container = document.getElementById("root") as HTMLElement;
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <LockWrapper>
      <App />
    </LockWrapper>
  </React.StrictMode>
);
